var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.648 8.5646L18.6479 8.56451L16.7453 7.22321L16.7453 7.2232C16.3011 6.91011 15.6877 7.22875 15.6877 7.77158V8.44195H6.70261C6.33208 8.44195 6.03164 8.74234 6.03164 9.11292C6.03164 9.48351 6.33209 9.78385 6.70261 9.78385H15.6877V10.4542C15.6877 11.0014 16.3049 11.3129 16.7452 11.0026L16.7452 11.0026L18.6477 9.66128C18.6477 9.66127 18.6478 9.66127 18.6478 9.66126C19.0219 9.39764 19.0301 8.83454 18.648 8.5646Z",
    fill: "#1B9075",
    stroke: "#1B9075",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0249 12.3279L16.0249 12.3279C15.7043 12.1425 15.2938 12.252 15.1082 12.5728L15.238 12.6479L15.1082 12.5728C13.9102 14.6438 11.6712 16.0337 9.11279 16.0337C5.29675 16.0337 2.1919 12.9288 2.1919 9.11279C2.1919 5.29675 5.29675 2.1919 9.11279 2.1919C11.6729 2.1919 13.9109 3.58304 15.1081 5.65274C15.2937 5.97357 15.7043 6.08297 16.0249 5.89759L16.0249 5.89758C16.3457 5.71203 16.4552 5.30157 16.2697 4.98084L16.2697 4.98082C14.8365 2.50313 12.1593 0.85 9.11279 0.85C4.54599 0.85 0.85 4.5456 0.85 9.11279C0.85 13.6796 4.5456 17.3756 9.11279 17.3756C12.1607 17.3756 14.8371 15.7213 16.2698 13.2447L16.2698 13.2447C16.4553 12.9239 16.3457 12.5135 16.0249 12.3279Z",
    fill: "#1B9075",
    stroke: "#1B9075",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7569df3a688ba8cdabd729c87bb4b670.svg";
export { ForwardRef as ReactComponent };